// app/(routes)/ai-examples/page.tsx
'use client';

import { IndustryWorkflowPublicListComponent } from '@/app/features/industry-workflows/components/IndustryWorkflowPublicListComponent';
import { useIndustryWorkflowsHook } from '@/app/features/industry-workflows/services_and_hooks/useIndustryWorkflowsHook';

export default function AIExamplesPage() {
  // "One Line to Rule Them All" - Blueprint pattern
  const { workflows, total, isLoading, isError, error } = useIndustryWorkflowsHook({
    limit: 100, // Get more workflows for public display
    includeUnpublished: true // Show all workflows including unpublished ones
  });

  return (
    <div className="container py-8 md:py-12">
      <IndustryWorkflowPublicListComponent
        workflows={workflows}
        totalCount={total}
        isLoading={isLoading}
        isError={isError}
        error={error as Error | null}
      />
    </div>
  );
}

